import { AnimatePresence, useDragControls } from 'framer-motion';
import React, { useRef, useState } from 'react';

import FadeInOut from 'components/animations/FadeInOut/FadeInOut';
import ContentMedia from 'components/ContentMedia/ContentMedia';
import Quote from 'components/Quote/Quote';
import useOverElement from 'hooks/useOverElement';
import { QuoteSectionCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './QuoteSection.styles';

const QuoteSection: React.FunctionComponent<QuoteSectionCMS> = ({
  quote,
  backgroundHexColor,
  image,
  ...rest
}) => {
  const [isHovering, setIsHovering] = useState(false);

  const dragControls = useDragControls();
  const dragConstrains = useRef<HTMLDivElement>(null);

  useOverElement(dragConstrains);

  const animateHoverImage = event => {
    dragControls.start(event, { snapToCursor: true });
  };

  return (
    <S.QuoteSectionWrapper
      backgroundHexColor={backgroundHexColor}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onMouseMove={animateHoverImage}
      ref={dragConstrains}
      {...rest}
    >
      <S.ImageWrapper
        drag
        dragControls={dragControls}
        dragConstraints={dragConstrains}
      >
        <AnimatePresence>
          {isHovering && (
            <FadeInOut duration={0.1}>
              {image && (
                <ContentMedia
                  media={image}
                  mediaType="image"
                  aspectRatio="default"
                />
              )}
            </FadeInOut>
          )}
        </AnimatePresence>
      </S.ImageWrapper>

      <S.QuoteWrapper>
        <Quote {...quote} quoteVariant="large" />
      </S.QuoteWrapper>
    </S.QuoteSectionWrapper>
  );
};

export default QuoteSection;
